import { useState } from 'react'
import { Checkbox, Dropdown } from "antd";


const MeetingStatusFilter = ({ meetings, selectedStatuses, onChange = () => true, ...props }) => {
    const statuses = TB.filter([...laravel.meeting_statuses], status => status !== 'Past');
    const [menuOpen, setMenuOpen] = useState(false);
    // const meetingStatusCount = TB.countBy(meetings, 'status');

    const items = statuses.map((status) => ({
        key: status,
        label: (
            <Checkbox
                checked={selectedStatuses.includes(status)}
                onChange={() => onChange(TB.xor(selectedStatuses, [status]))}
                name={`checkbox${status}`}
                id={`checkbox${status}`}
                // disabled={!meetingStatusCount[status]}
                className="form-check-label text-xs px-3 py-1.5 w-full"
            >
                {status}
            </Checkbox>
        ),
    }));

    return (
        <Dropdown
            open={menuOpen}
            onOpenChange={setMenuOpen}
            menu={{
                items,
                disabled: props.disabled,
                className: 'p0 [&>.ant-dropdown-menu-item]:p-0'
            }}
            trigger={['click']}
            onClick={e => e.stopPropagation()}
        >
            <button type="button" className="btn btn-white btn-outline-dark ml-auto">
                <i className="fas fa-filter"></i>
            </button>
        </Dropdown>
    )
}

export default MeetingStatusFilter;